import styled from "styled-components"
import { medScreen, mobile, mobilePortrait } from "../../Responsive"


export const Square = styled.div`
    position: absolute;
    top: 5%;
    left: 100%;
    width: 90%;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--darkGrey);
    border-radius: 5%;
    opacity: 0.5;
    transition: .5s;

    @media (hover: none) {
        left: 5%;   
    }
`

export const Info = styled.div`
    position: absolute;
    top: 0;
    left: 100%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: .5s;

    @media (hover: none) {
        left: 0;   
    }
`

export const Container = styled.div`
    flex: 1;
    margin: 3px;
    height: 70vh;
    position: relative;
    overflow: hidden;

    &:hover ${Square} {
        left: 5%;
    }

    &:hover ${Info} {
        left: 0;
    }

    ${mobile({ width: "100vw" })}
`

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;

    ${mobile({ height: "70vh" })}
    ${mobilePortrait({ height: "40vh" })}
`

export const Title = styled.h1`
    color: var(--white);
    margin-bottom: 20px;

    @media screen and (max-width: ${medScreen}) {
        font-size: var(--fontM);
    }
`


